// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 640px) {
  .side-menu-parent {
    min-width: 400px;
    width: 400px;
  }

  #lookanglesmultisite-menu {
    width: 450px;
  }

  #dops-menu {
    width: 400px;
  }

  #menu-satellite-collision,
  #FindSatPlugin-bottom-icon {
    display: inline;
  }

  .sat-info-value {
    width: 65%;
  }

  footer {
    margin-top: -100px;
    position: absolute;
    bottom: 0px;
    height: 120px;
    width: 100%;
  }

  #bottom-icons-container {
    width: 100%;
    height: var(--bottom-menu-height);
  }

  #footer-toggle-wrapper {
    width: 100%;
    z-index: 1;
    position: relative;
  }

  .footer-slide-down {
    bottom: -115px !important;
    height: 120px !important;
    top: auto !important;
  }

  .footer-slide-trans {
    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .footer-slide-up {
    bottom: 0px !important;
    top: auto !important;
  }

  .ui-timepicker-div dl dd div {
    width: 150px !important;
  }

  #datetime-text {
    border-left: 5px solid var(--color-dark-border);
    padding: 0px 10px 0px 10px;
    vertical-align: bottom;
  }

  #jday {
    display: block;
  }

  #toast-container {
    min-width: 0px;
    right: 5%;
  }

  .sat-infobox-links {
    display: block;
    justify-content: flex-start;
    text-align: unset;
  }

  #polar-plot {
    width: 95%;
  }

  #sensor-timeline-sensor-list,
  #multi-sensor-look-angles-sensor-list {
    display: grid;
    justify-content: space-evenly;
    justify-items: stretch;
    grid-row-gap: 10px;
    grid-column-gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./public/css/responsive-sm.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,2GAA2G;EAC7G;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+CAA+C;IAC/C,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,cAAc;IACd,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;AACF","sourcesContent":["@media (min-width: 640px) {\n  .side-menu-parent {\n    min-width: 400px;\n    width: 400px;\n  }\n\n  #lookanglesmultisite-menu {\n    width: 450px;\n  }\n\n  #dops-menu {\n    width: 400px;\n  }\n\n  #menu-satellite-collision,\n  #FindSatPlugin-bottom-icon {\n    display: inline;\n  }\n\n  .sat-info-value {\n    width: 65%;\n  }\n\n  footer {\n    margin-top: -100px;\n    position: absolute;\n    bottom: 0px;\n    height: 120px;\n    width: 100%;\n  }\n\n  #bottom-icons-container {\n    width: 100%;\n    height: var(--bottom-menu-height);\n  }\n\n  #footer-toggle-wrapper {\n    width: 100%;\n    z-index: 1;\n    position: relative;\n  }\n\n  .footer-slide-down {\n    bottom: -115px !important;\n    height: 120px !important;\n    top: auto !important;\n  }\n\n  .footer-slide-trans {\n    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .footer-slide-up {\n    bottom: 0px !important;\n    top: auto !important;\n  }\n\n  .ui-timepicker-div dl dd div {\n    width: 150px !important;\n  }\n\n  #datetime-text {\n    border-left: 5px solid var(--color-dark-border);\n    padding: 0px 10px 0px 10px;\n    vertical-align: bottom;\n  }\n\n  #jday {\n    display: block;\n  }\n\n  #toast-container {\n    min-width: 0px;\n    right: 5%;\n  }\n\n  .sat-infobox-links {\n    display: block;\n    justify-content: flex-start;\n    text-align: unset;\n  }\n\n  #polar-plot {\n    width: 95%;\n  }\n\n  #sensor-timeline-sensor-list,\n  #multi-sensor-look-angles-sensor-list {\n    display: grid;\n    justify-content: space-evenly;\n    justify-items: stretch;\n    grid-row-gap: 10px;\n    grid-column-gap: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
